.reorderableNavItem {
  transition: transform 150ms ease;
}

/* Shifts are only animated during a drag. Once the drag ends the tabs are already
   in their final positions, so animating the transforms away would make the
   displaced tabs appear to slide in from the side */
.reorderableNavItemStatic {
  transition: none;
}

.reorderableNavItemDraggable {
  cursor: grab;
}

.reorderableNavItemDragging {
  opacity: 0;
  cursor: grabbing;
}

.reorderableNavItemShiftStart {
  transform: translateX(calc(var(--mos-reorderable-drag-width, 0px) * -1));
}

.reorderableNavItemShiftEnd {
  transform: translateX(var(--mos-reorderable-drag-width, 0px));
}

.reorderableNavDragImage {
  position: absolute;
  top: -1000px;
  left: -1000px;
  pointer-events: none;
}
